import { render, staticRenderFns } from "./forex-dictionary.vue?vue&type=template&id=608b4c7a&scoped=true"
import script from "./forex-dictionary.vue?vue&type=script&lang=js"
export * from "./forex-dictionary.vue?vue&type=script&lang=js"
import style0 from "./forex-dictionary.vue?vue&type=style&index=0&id=608b4c7a&prod&lang=css"
import style1 from "./forex-dictionary.vue?vue&type=style&index=1&id=608b4c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608b4c7a",
  null
  
)

export default component.exports